/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseEditorialCopyFragment, EditorialCopyFragment, FullEditorialCopyFragment} from '@amblique/contentful/app/contentful/fragments/editorial-copy';

/**
 * Get a single EditorialCopy by ID (base - scalars only)
 */
export const getBaseEditorialCopyById = gql`
  ${BaseEditorialCopyFragment}

  query GetBaseEditorialCopyById($id: String!, $locale: String!, $preview: Boolean) {
    editorialCopy(id: $id, locale: $locale, preview: $preview) {
      ...BaseEditorialCopyFragment
    }
  }
`;

/**
 * Get a single EditorialCopy by ID (standard - 1 level deep)
 */
export const getEditorialCopyById = gql`
  ${EditorialCopyFragment}

  query GetEditorialCopyById($id: String!, $locale: String!, $preview: Boolean) {
    editorialCopy(id: $id, locale: $locale, preview: $preview) {
      ...EditorialCopyFragment
    }
  }
`;

/**
 * Get a single EditorialCopy by ID (full - 2 levels deep)
 */
export const getFullEditorialCopyById = gql`
  ${FullEditorialCopyFragment}

  query GetFullEditorialCopyById($id: String!, $locale: String!, $preview: Boolean) {
    editorialCopy(id: $id, locale: $locale, preview: $preview) {
      ...FullEditorialCopyFragment
    }
  }
`;

/**
 * Get all EditorialCopy entries with pagination (base - scalars only)
 */
export const getBaseEditorialCopys = gql`
  ${BaseEditorialCopyFragment}

  query GetBaseEditorialCopys(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [EditorialCopyOrder]
    $where: EditorialCopyFilter
    $preview: Boolean
  ) {
    editorialCopyCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseEditorialCopyFragment
      }
    }
  }
`;

/**
 * Get all EditorialCopy entries with pagination (standard - 1 level deep)
 */
export const getEditorialCopys = gql`
  ${EditorialCopyFragment}

  query GetEditorialCopys(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [EditorialCopyOrder]
    $where: EditorialCopyFilter
    $preview: Boolean
  ) {
    editorialCopyCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...EditorialCopyFragment
      }
    }
  }
`;

/**
 * Get all EditorialCopy entries with pagination (full - 2 levels deep)
 */
export const getFullEditorialCopys = gql`
  ${FullEditorialCopyFragment}

  query GetFullEditorialCopys(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [EditorialCopyOrder]
    $where: EditorialCopyFilter
    $preview: Boolean
  ) {
    editorialCopyCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullEditorialCopyFragment
      }
    }
  }
`;
